import {
  PlusCircleIcon,
  XCircleIcon,
  XMarkIcon,
} from "@heroicons/react/20/solid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import HeaderBar from "../../components/HeaderBar";

function EditProduct() {
  const IMAGE_LIMIT = 4; // Limit for the number of images

  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState({});
  const [artikelName, setArtikelName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [productFee, setProductFee] = useState("");
  const [teileCode, setTeileCode] = useState("OEM");
  const [partsNumber, setPartsNumber] = useState("");
  const [codeString, setCodeString] = useState([]);
  const [category, setCategory] = useState("reifen");

  const [selectedManufacturer, setSelectedManufacturer] =
    useState("harley-davidson");
  const [zustand, setRadioValue] = useState("Neu");

  const [msg, setMsg] = useState("");

  const [selector, setSelector] = useState("");
  const [emailCheck, setEmailCheck] = useState("");
  const [telefonCheck, setTelefonCheck] = useState("");
  const initialOptions = ["OEM", "MCS", "CCE", "Zodiac", "PE"];
  const [options, setOptions] = useState(initialOptions);

  const [isAdding, setIsAdding] = useState(false);
  const [newOption, setNewOption] = useState("");
  const [imageMsg, setImageMsg] = useState("");
  const [files, setFiles] = useState([]);
  const [images, setImages] = useState([]);
  useEffect(() => {
    axios
      .get(`https://dealersonly.parts/beta/api/user/productsCode/TeileCodes`)
      .then((res) => {
        const fetchedOptions = res.data;

        // Combine initial options with fetched options and remove duplicates
        const newOptions = Array.from(new Set([...options, ...fetchedOptions]));

        // Update state with new options
        setOptions(newOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);

    if (selectedFiles.length + images.length > IMAGE_LIMIT) {
      setImageMsg(`Sie können maximal ${IMAGE_LIMIT} Bilder hochladen.`);
      return;
    }

    const updatedFiles = [...files, ...selectedFiles];
    setFiles(updatedFiles);

    const selectedImages = selectedFiles.map((file) =>
      URL.createObjectURL(file)
    );
    const updatedImages = [...images, ...selectedImages];
    setImages(updatedImages);
    setImageMsg(""); // Clear any previous messages
  };
  const handleRemoveImage = (index) => {
    const baseURL = "https://dealersonly.parts/beta/app/";
    const alreadyUploaded = images.filter((image) => image.startsWith(baseURL));

    const numAlreadyUploaded = alreadyUploaded.length;

    if (index >= numAlreadyUploaded) {
      const adjustedIndex = index - numAlreadyUploaded;
      const updatedFiles = files.filter((_, i) => i !== adjustedIndex);
      setFiles(updatedFiles);
    }

    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
    setImageMsg(""); // Clear any previous messages
  };

  useEffect(() => {
    axios
      .get(`https://dealersonly.parts/beta/api/user/products/${id}`)
      .then((res) => {
        console.log(res);
        setProduct(res.data);
        setArtikelName(res.data.title);
        setDescription(res.data.description);
        setCategory(res.data.category);
        setCodeString(res.data.teileNummer);
        setPrice(res.data.price);
        setSelector(res.data.selector);
        setEmailCheck(res.data.contactPreferenceEmail);
        setTelefonCheck(res.data.contactPreferenceTelefon);
        const hasImages =
          res.data.productImages &&
          res.data.productImages.length > 0 &&
          res.data.productImages[0] !== "";

        if (hasImages) {
          const baseURL = "https://dealersonly.parts/beta/app/";
          const updatedImages = res.data.productImages.map(
            (image) => `${baseURL}${image}`
          );
          setImages(updatedImages); // Set the updated images with the base URL prepended
        } else {
          setImages([]); // Handle case where there are no images
        }
      })
      .catch((error) => {
        if (error.response.data !== 201) navigate("../../");
      });
  }, []);

  useEffect(() => {
    if (Object.keys(product).length !== 0) {
      const initialPrice = parseFloat(
        product.price.toString().replace(",", ".")
      );
      setPrice(initialPrice.toFixed(2)); // Achten Sie darauf, dass das Format korrekt ist.
      const fee = calculateProductFee(initialPrice, product.type);
      setProductFee(fee);
    }
  }, [product]); // Abhängigkeiten: Ändert sich, wenn das Produkt geladen wird

  const calculateProductFee = (priceValue, productType) => {
    switch (productType) {
      case "originalparts":
        return (priceValue * 0.05).toFixed(2);
      case "rollingchassis":
        return "50";
      case "customparts":
        return "Xx mtl.";
      default:
        return (priceValue * 0.05).toFixed(2);
    }
  };

  const deleteProduct = () => {
    axios
      .post(
        "https://dealersonly.parts/beta/api/products/delete",
        { id: id },
        {}
      )
      .then((res) => {
        navigate("../../");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSelectChange = (event) => {
    const value = event.target.value;
    if (value === "add-new") {
      setIsAdding(true);
    } else {
      setTeileCode(value);
      setIsAdding(false);
    }
  };
  const handleConfirmNewOption = () => {
    let capitalizedOption = newOption.toUpperCase();
    if (capitalizedOption && !options.includes(capitalizedOption)) {
      setOptions((prev) => [...prev, capitalizedOption]);
      setTeileCode(capitalizedOption);
    }
    setIsAdding(false);
    setNewOption("");
  };

  const handleCancelNewOption = () => {
    setIsAdding(false);
    setNewOption("");
  };
  const handlePrice = (e) => {
    let converted = e.replace(",", ".");
    let priceValue = parseFloat(converted);

    setPrice(converted);
    const fee = calculateProductFee(priceValue, product.type); // Verwende die neue Hilfsfunktion
    setProductFee(fee);
  };

  const setTeilenummer = () => {
    if (teileCode === "" || partsNumber === "") {
      setMsg("Bitte Typ und Nummer auswählen");
      return;
    }
    setMsg("");
    setCodeString([...codeString, teileCode + " - " + partsNumber]);

    setTeileCode("OEM");
    setPartsNumber("");
  };

  const removeCode = (e, id) => {
    e.preventDefault();
    let array = [...codeString]; // make a separate copy of the array
    if (id !== -1) {
      array.splice(id, 1);
      setCodeString(array);
    }
  };

  const UpdateProduct = async (e) => {
    e.preventDefault();

    let formData = new FormData();
    formData.append("artikelName", artikelName);
    formData.append("description", description);
    files.forEach((file, index) => {
      formData.append(`files`, file); // Ensure this key matches the one expected by your backend
    });
    formData.append("partsNumber", partsNumber);
    formData.append("selectedManufacturer", selectedManufacturer);
    formData.append("codeListe", codeString);
    formData.append("zustand", zustand);
    formData.append("category", category);
    formData.append("price", price);
    formData.append("selector", selector);
    formData.append("contactPreferenceTelefon", telefonCheck);
    formData.append("contactPreferenceEmail", emailCheck);
    const baseURL = "https://dealersonly.parts/beta/app/";
    const alreadyUploaded = images.filter((image) => image.startsWith(baseURL));
    alreadyUploaded.forEach((item, index) => {
      // Remove the baseURL from the item before appending
      const cleanItem = item.replace(baseURL, "");
      formData.append("alreadyUploaded", cleanItem);
    });
    if (product.sold) {
      formData.append("oem", product.oem);
      formData.append("type", product.type);
    }

    try {
      if (product.sold) {
        await axios
          .post(
            `https://dealersonly.parts/beta/api/user/products/new`,
            formData
          )
          .then((res) => {
            navigate("../../");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        await axios
          .post(
            `https://dealersonly.parts/beta/api/user/products/edit/${id}`,
            formData
          )
          .then((res) => {
            navigate("../../");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (error) {
      setMsg(error.response.data);
    }
  };
  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  return (
    <>
      <HeaderBar title="Artikel bearbeiten" back={1} />
      <div className="mt-10 sm:mt-0">
        <div className="md:grid md:grid-cols-3 md:gap-6">
          <div className="md:col-span-1">
            <div className="px-4 sm:px-0">
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                Artikelinformationen
              </h3>
              <p className="mt-1 text-sm text-gray-600">
                Je mehr Felder ausführlich ausgefüllt werden, desto besser lässt
                sich der Artikel finden.
              </p>
            </div>
          </div>
          <div className="mt-5 md:col-span-2 md:mt-0">
            <form onSubmit={UpdateProduct}>
              <div className="overflow-hidden shadow sm:rounded-md">
                <div className="bg-white px-4 py-5 sm:p-6">
                  {msg && (
                    <div className="rounded-md bg-red-50 p-4 mb-2">
                      <div className="flex">
                        <div className="flex-shrink-0">
                          <XCircleIcon
                            className="h-5 w-5 text-red-400"
                            aria-hidden="true"
                          />
                        </div>
                        <div className="ml-3">
                          <h3 className="text-sm font-medium text-red-800">
                            Fehler beim erstellen des Artikels
                          </h3>
                          <div className="mt-2 text-sm text-red-700">
                            <ul
                              role="list"
                              className="list-disc space-y-1 pl-5"
                            >
                              <li>{msg}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="grid grid-cols-6 gap-6">
                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="first-name"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Artikelname
                      </label>
                      <input
                        type="text"
                        name="artikelName"
                        id="artikelName"
                        autoComplete="product-name"
                        value={artikelName}
                        onChange={(e) => setArtikelName(e.target.value)}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="country"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Teilekategorie
                      </label>
                      <select
                        id="category"
                        name="category"
                        autoComplete="category-name"
                        className="mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                        defaultValue={category}
                        onChange={(e) => setCategory(e.target.value)}
                      >
                        <option disabled value="">
                          Bitte wählen
                        </option>
                        <option value="Armaturen Lenker">
                          Armaturen Lenker
                        </option>
                        <option value="Auspuff">Auspuff</option>
                        <option value="Beleuchtung">Beleuchtung</option>
                        <option value="Bremsen">Bremsen</option>
                        <option value="Elektrik">Elektrik</option>
                        <option value="Fender">Fender</option>
                        <option value="Gabel">Gabel</option>
                        <option value="Getriebe">Getriebe</option>
                        <option value="Lenker">Lenker</option>
                        <option value="Motor">Motor</option>
                        <option value="Packtaschen">Packtaschen</option>
                        <option value="Rahmen">Rahmen</option>
                        <option value="Räder">Räder</option>
                        <option value="Schwinge">Schwinge</option>
                        <option value="Sissy Bar">Sissy Bar</option>
                        <option value="Sitze">Sitze</option>
                        <option value="Tacho / Drehzahlmesser">
                          Tacho / Drehzahlmesser
                        </option>
                        <option value="Tank">Tank</option>
                        <option value="Verklevalueungen">
                          Verklevalueungen
                        </option>
                        <option value="Öl">Öl</option>
                        <option value="Weitere">Weitere</option>
                      </select>
                    </div>
                    <div className="col-span-3 sm:col-span-1">
                      <label
                        htmlFor="category"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Lieferant
                      </label>
                      {!isAdding ? (
                        <select
                          id="category"
                          name="category"
                          autoComplete="category-name"
                          className="mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                          value={teileCode}
                          onChange={handleSelectChange}
                        >
                          {options.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                          <option value="add-new">Add more...</option>
                        </select>
                      ) : (
                        <div className="relative flex items-center mt-1">
                          <input
                            type="text"
                            className="w-full pl-3 pr-10 rounded-md border border-gray-300 bg-white py-2 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                            value={newOption}
                            onChange={(e) => setNewOption(e.target.value)}
                            autoFocus
                          />
                          <button
                            className="absolute right-8 top-1/2 transform -translate-y-1/2 text-green-500 text-xs"
                            onClick={handleConfirmNewOption}
                          >
                            ✔️
                          </button>
                          <button
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-red-500 text-xs"
                            onClick={handleCancelNewOption}
                          >
                            ❌
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="col-span-4 sm:col-span-2">
                      <label
                        htmlFor="company-website"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Teilenummer
                      </label>
                      <div className="mt-1 flex rounded-md shadow-sm">
                        <input
                          type="text"
                          name="teilenummer"
                          id="teilenummer"
                          className="block w-full flex-1 rounded-none rounded-l-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                          placeholder="123-456-789"
                          value={partsNumber}
                          onChange={(e) => setPartsNumber(e.target.value)}
                        />
                        <span className="inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 px-3 text-sm text-gray-500">
                          <button
                            type="button"
                            onClick={() => setTeilenummer()}
                          >
                            <PlusCircleIcon className="h-6 w-6" />
                          </button>
                        </span>
                      </div>
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="company-website"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Nummernliste
                      </label>
                      <div className="mt-1 flex flex-wrap gap-2">
                        {codeString?.map((item, idx) => (
                          <div
                            className="pointer-events-none inset-x-0 bottom-0 sm:flex sm:justify-center sm:pr-2 sm:pb-3"
                            key={idx}
                            id={`parts-number-${idx}`}
                          >
                            <div className="pointer-events-auto flex items-center justify-between gap-x-6 bg-gray-900 py-3 px-4 rounded-xl sm:py-1.5 sm:pr-3.5 sm:pl-4">
                              <p className="text-sm leading-6 text-white">
                                <strong className="font-semibold">
                                  {item}
                                </strong>
                              </p>
                              <button
                                type="button"
                                onClick={(e) => {
                                  removeCode(e, idx);
                                }}
                                className="-m-1.5 flex-none"
                              >
                                <span className="sr-only">Dismiss</span>
                                <XMarkIcon
                                  className="h-5 w-5 text-white"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="col-span-6 sm:col-span-6">
                      <label
                        htmlFor="about"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Zusätzliche Information
                      </label>
                      <div className="mt-1">
                        <textarea
                          id="description"
                          name="description"
                          rows={3}
                          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                          placeholder="Text der den Artikel zusätzlich beschreibt"
                          defaultValue={description}
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        />
                      </div>
                      <p className="mt-2 text-sm text-gray-500">
                        Freitext für Informationen die kein eigens Feld haben.
                      </p>
                    </div>

                    <div className="col-span-6">
                      <fieldset>
                        <label className="text-sm font-medium text-gray-700">
                          In welchem Zustand befindet sich der Artikel?
                        </label>
                        <div className="mt-4 space-y-4">
                          <div className="flex items-center">
                            <input
                              id="push-everything"
                              name="push-notifications"
                              type="radio"
                              value="Neu"
                              checked={zustand === "Neu"}
                              onChange={(e) =>
                                setRadioValue(e.currentTarget.value)
                              }
                              className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                            />
                            <label
                              htmlFor="push-everything"
                              className="ml-3 block text-sm font-medium text-gray-700"
                            >
                              Neu
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              id="push-email"
                              name="push-notifications"
                              type="radio"
                              value="Gebraucht"
                              checked={zustand === "Gebraucht"}
                              onChange={(e) =>
                                setRadioValue(e.currentTarget.value)
                              }
                              className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                            />
                            <label
                              htmlFor="push-email"
                              className="ml-3 block text-sm font-medium text-gray-700"
                            >
                              Gebraucht
                            </label>
                          </div>
                        </div>
                      </fieldset>
                    </div>

                    <div className="col-span-6">
                      <label className="block text-sm font-medium text-gray-700">
                        Artikelfoto
                      </label>
                      <div className="mt-1 flex flex-col justify-center items-center rounded-md border-2 border-dashed border-gray-300 px-6 pt-5 pb-6">
                        <div className="space-y-1 text-center">
                          <svg
                            className="mx-auto h-12 w-12 text-gray-400"
                            stroke="currentColor"
                            fill="none"
                            viewBox="0 0 48 48"
                            aria-hidden="true"
                          >
                            <path
                              d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <div className="flex text-sm text-gray-600">
                            <label
                              htmlFor="file-upload"
                              className="relative cursor-pointer rounded-md bg-white font-medium text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:text-indigo-500"
                            >
                              <span>Bild hochladen</span>
                              <input
                                id="file-upload"
                                name="file-upload"
                                type="file"
                                onChange={handleFileChange}
                                multiple
                                accept="image/png, image/jpeg"
                                className="sr-only"
                              />
                            </label>
                          </div>
                          <p className="text-xs text-gray-500">
                            PNG, JPG bis 10MB
                          </p>
                        </div>
                        <div className="flex flex-wrap mt-4 w-full">
                          {images.map((image, index) => (
                            <div key={index} className="relative w-1/4 p-2">
                              <img
                                className=" w-full"
                                src={image}
                                alt={`preview image ${index + 1}`}
                              />
                              <button
                                type="button"
                                className="absolute top-2 right-2 m-2  bg-white rounded-full text-red-500 hover:text-red-700 focus:outline-none"
                                onClick={() => handleRemoveImage(index)}
                              >
                                <XCircleIcon className="h-5 w-5" />
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                      {imageMsg && (
                        <h3 className="text-sm font-medium text-yellow-800">
                          {imageMsg}
                        </h3>
                      )}
                    </div>

                    <div className="col-span-6">
                      <fieldset>
                        <legend className="text-sm font-semibold leading-6 text-gray-900">
                          Kontaktmöglichkeit (mindestens 1)
                        </legend>
                        <p className="text-sm leading-6 text-gray-500">
                          Wird nur für diesen Artikel übernommen.
                        </p>

                        <div className="mt-3 grid grid-cols-12 gap-6">
                          <div className="col-span-6">
                            <label
                              htmlFor="mail"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Per Mail
                            </label>
                            <input
                              type="text"
                              name="mail"
                              id="mail"
                              value={emailCheck}
                              onChange={(e) => setEmailCheck(e.target.value)}
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            />
                          </div>
                          <div className="col-span-6">
                            <label
                              htmlFor="telefon"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Per Telefon
                            </label>
                            <input
                              type="text"
                              name="telefon"
                              id="telefon"
                              autoComplete="product-name"
                              value={telefonCheck}
                              onChange={(e) => setTelefonCheck(e.target.value)}
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            />
                          </div>
                        </div>
                      </fieldset>
                    </div>

                    <div className="col-span-6 sm:col-span-6 lg:col-span-6">
                      <label
                        htmlFor="postal-code"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Artikelpreis
                      </label>
                      <input
                        type="text"
                        name="preis"
                        id="preis"
                        readOnly={product.sold ? false : true}
                        disabled={product.sold ? false : true}
                        value={price}
                        onChange={(e) => {
                          setPrice(e.target.value);
                          handlePrice(e.target.value);
                        }}
                        autoComplete="preis"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex  justify-end bg-gray-50">
                  <div className=" px-4 py-3 text-right sm:px-6">
                    <button
                      type="button"
                      onClick={() => deleteProduct()}
                      className="inline-flex justify-center rounded-md border border-transparent bg-red-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                    >
                      Artikel löschen
                    </button>
                  </div>
                  <div className="px-4 py-3 text-right sm:px-6">
                    <button
                      type="submit"
                      className="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      {product.sold
                        ? `Artikel für ${formatter.format(
                            productFee
                          )} neu einstellen`
                        : "Artikel aktualisieren"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditProduct;
